export default "__VITE_ASSET__B5rHdKh5__"